import { ReactNode } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import TrustBar from './TrustBar';
import WhyChooseUsSection from './WhyChooseUsSection';
import ServiceAreasSection from './ServiceAreasSection';
import TestimonialsSection from './TestimonialsSection';
import FinalCTASection from './FinalCTASection';
import MidCTABanner from './MidCTABanner';

export interface PageTemplateProps {
  hero: ReactNode;
  mainSection: ReactNode;
  aiBlock: ReactNode;
  processSection: ReactNode;
  faqSection: ReactNode;
  midCTA1?: string;
  midCTA2?: string;
  midCTA3?: string;
}

export default function PageTemplate({
  hero,
  mainSection,
  aiBlock,
  processSection,
  faqSection,
  midCTA1 = 'Ready to protect your Utah home with a quality roof?',
  midCTA2 = 'Simple process, zero pressure — get your free estimate today.',
  midCTA3 = 'Join 1,200+ satisfied Utah homeowners — contact us today.',
}: PageTemplateProps) {
  return (
    <div className="font-body">
      <Navbar />
      <main className="pb-16 lg:pb-0">
        {/* Section 1: Hero */}
        {hero}
        {/* Section 2: Trust Bar */}
        <TrustBar />
        {/* Section 3: Services / Adapted */}
        {mainSection}
        {/* Mid-page CTA (after services) */}
        <MidCTABanner text={midCTA1} />
        {/* Section 4: AI Answer Block */}
        {aiBlock}
        {/* Section 5: Process */}
        {processSection}
        {/* Mid-page CTA (after process) */}
        <MidCTABanner text={midCTA2} />
        {/* Section 6: Why Choose Us */}
        <WhyChooseUsSection />
        {/* Section 7: Service Areas */}
        <ServiceAreasSection />
        {/* Section 8: Testimonials */}
        <TestimonialsSection />
        {/* Mid-page CTA (after testimonials) */}
        <MidCTABanner text={midCTA3} />
        {/* Section 9: FAQ */}
        {faqSection}
        {/* Section 10: Final CTA */}
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
}
